var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 13,
    viewBox: "0 0 8 13",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.723
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.786987 1.52698L6.61899 5.61498C6.78382 5.69961 6.92329 5.82639 7.02322 5.98242C7.12315 6.13846 7.17996 6.31817 7.18789 6.50329C7.19581 6.68841 7.15457 6.87233 7.06834 7.03633C6.98211 7.20033 6.85398 7.33857 6.69699 7.43698L0.786987 11.583",
    stroke: "white",
    strokeWidth: 1.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight);
export default __webpack_public_path__ + "static/media/chevron-right.93bd04a3ee5d5a12a76554ec2674a081.svg";
export { ForwardRef as ReactComponent };